import type { DpsMiniAppBackendLeaderboardTypeEnum } from "@tradingApp/api/types/DpsMiniAppBackend";
import { numberIsFinite } from "@tradingApp/helpers/numbers/numberIsFinite";
import clsx from "clsx";
import type { ReactElement } from "react";

export function leaderboardValueFormatter(
  type: DpsMiniAppBackendLeaderboardTypeEnum,
  value?: number | null,
): string | undefined | ReactElement {
  if (!numberIsFinite(value)) {
    return;
  }

  switch (true) {
    case type === "ORDER_WIN_RATE":
      return `🎯 ${value.toFixed(2)}%`;
    case type === "ORDER_STREAK":
      return (
        <div
          className={clsx(
            value === 0 && "opacity-50",
            value === 2 && "text-orange-300",
            value === 3 && "text-orange-400",
            value === 4 && "text-orange-500",
            value > 4 && "text-orange-600",
          )}
        >
          🔥 {value}
        </div>
      );
    case type === "REFERRAL":
      return `👤 ${value.toLocaleString("en-US")}`;
    default:
      return String(value);
  }
}
